import { HttpParams } from '@angular/common/http';
import { BHttpUrlEncodingCodec } from './encoder';

export function createHttpParams(obj?: any) {
  let params = new HttpParams({ encoder: new BHttpUrlEncodingCodec() });

  if (obj) {
    for (const key in obj) {
      if (obj[key] != null) {
        let value = obj[key];

        if (typeof value === 'object') {
          value = JSON.stringify(value);
        }

        params = params.set(key, value);
      }
    }
  }

  return params;
}
